// LIBRARIES //
import React from 'react';
import styled from 'styled-components';

// COMPONENTS //
import NoticeCard from 'components/ui/ActivityCard/NoticeCard';

// HELPERS //
import { getCurrentLocale } from 'helpers/i18n';
import { toFriendlyDateTimeString } from 'helpers/Formatter';

const StyledCard = styled.div`
  margin-bottom: 24px;
`;

const NoticeCardList = ({ notices, propertyId, leaseId }) => {
  const selectSharedResidentAndNoticeProperty = notice => {
    const property = notice.properties.find(
      property => parseInt(propertyId) === parseInt(property.value)
    );
    if (property) return property.label;
    return null;
  };

  return notices.map(notice => (
    <StyledCard>
      <NoticeCard
        id={notice.id}
        title={notice.name}
        propertyName={selectSharedResidentAndNoticeProperty(notice)}
        noticeDate={toFriendlyDateTimeString(notice.post_date, { language: getCurrentLocale() })}
        noticeDetails={notice.description}
        wasSentToUser={
          !notice.not_delivered_to_lease_ids || !notice.not_delivered_to_lease_ids.includes(leaseId)
        }
      />
    </StyledCard>
  ));
};

export default NoticeCardList;
